import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const UnlinkIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.83594 7L3.42637 8.28272C2.87029 8.83881 2.5505 9.59545 2.55634 10.3907C2.56219 11.1859 2.87498 11.9471 3.45745 12.5116C4.02191 13.0941 4.78333 13.4069 5.57841 13.4127C6.39162 13.4187 7.13036 13.1169 7.68648 12.5608L8.83594 11.5M11.3359 9L12.5663 7.71739C13.1224 7.1613 13.4422 6.40466 13.4363 5.60945C13.4305 4.81424 13.1177 4.05299 12.5352 3.4885C11.9709 2.92417 11.2096 2.61137 10.4144 2.60552C9.61919 2.59968 8.86245 2.90131 8.30632 3.45742L7.33594 4.5M5.73841 10.2182L10.2053 5.75126"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66236 3.03787C2.38284 2.73218 2.3545 2.3031 2.59905 2.07949C2.8436 1.85588 3.26843 1.92241 3.54795 2.2281L13.3327 12.929C13.6122 13.2347 13.6405 13.6638 13.396 13.8874C13.1514 14.111 12.7266 14.0445 12.4471 13.7388L2.66236 3.03787Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

UnlinkIcon.displayName = 'UnlinkIcon';
